<template>
  <v-app
    :class="classes"
  >
    <template v-if="preloading" />
    <router-view v-else />
  </v-app>
</template>

<script>
import oldUrls from './oldUrls.json'
import sharedMethods from './methods/sharedMethods'
import api from './store/api.js'
import { createHelpers } from 'vuex-map-fields'
import state from './store/state.js'
import sharedComputed from '@/methods/sharedComputed'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'App',

  data () {
    return {
      preloading: true,
    }
  },

  created () {
    this.loadLocalFavorites()
    this.tryOldUrlRedirect()

    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.get('showArticleOnly') && parseInt(urlParams.get('showArticleOnly')) === 1) {
      this.showArticleOnly = true
    }

    this.openTs = +new Date()
    this.lang = this.getLangFromUrl(this.$route.path) || 'en'
    if (!this.languages.includes(this.lang)) {
      this.lang = 'en'
    }
    this.$i18n.locale = this.lang
    this.isHomepage = this.homepage

    if (this.$route.name === 'calendar') {
      this.preloading = false
      return
    } else {
      // Is site app, so set background image
      // console.log('apply background prop correct')
      // document.documentElement.style.setProperty('--background-prop', getComputedStyle(document.documentElement).getPropertyValue('--background-prop-img'))
    }

    this.setHtmlTagLang()

    this.$store.dispatch('getHotObjects').then(response => {
      this.preloadSelectedObjectInitialImages()
    })
    this.getBookingFormInfoFromUrl()
    // First priority stuff

    api.getSiteMenu().then(response => {
      if (response.items) {
        this.$store.dispatch('setVal', {
          k: 'menuResponse',
          v: response.items
        })
        this.setPagesById(response.items)
        // First priority stuff
        api.getTemplateVars().then(response => {
          this.setTemplateVarsByLang(response.items)
          this.preloading = false
        })
        // Second priority stuff
        api.getSiteBanners().then(response => {
          this.setBannersByLang(response.items)
          api.getGalleries().then(response => {
            this.setGalleriesByArticleId(response.items)
          })
        })
        this.$store.dispatch('getFeatures')
        api.getBookingExtras().then(response => {
          this.bookingExtras = response.items
        })
        api.getObjectRegions().then(response => {
          this.objectRegions = response.items
        })
        // Weather is disabled
        // api.getWeather().then(response => {
        //   if (response && response.items && response.items[0] && response.items[0].jsonData) {
        //     try {
        //       this.weather = JSON.parse(response.items[0].jsonData)
        //     } catch (err) {
        //       // eslint-disable-next-line no-console
        //       console.log('weather json broken', err)
        //     }
        //   }
        // })
      }
    })
    window.addEventListener('resize', this.resizeHandler)
    window.addEventListener('scroll', this.scrollHandler)
    this.updateWindowWidth()
  },

  destroyed () {
    window.removeEventListener('resize', this.resizeHandler)
    window.removeEventListener('scroll', this.scrollHandler)
  },

  watch: {
    homepage () {
      this.isHomepage = this.homepage
    },

    routeFullPath () {
      const langBefore = this.lang
      const newLang = this.getLangFromUrl(this.$route.path)
      if (newLang && newLang !== langBefore && langBefore) {
        this.lang = newLang
        this.$i18n.locale = newLang
      }
      this.getBookingFormInfoFromUrl()
    },

    lang () {
      this.setHtmlTagLang()
    },
  },

  computed: {
    ...mapFields(Object.keys(state)),
    ...sharedComputed,

    classes () {
      return [
        (this.isDesktopView ? 'desktop-view' : 'mobile-view'),
        (this.showSeeBackground ? 'app-container-background' : ''),
      ]
    },

    showSeeBackground () {
      return this.$route.name !== 'calendar' && this.isMobileView
    },

    menuResponse () {
      return this.$store.getters.menuResponse
    },
  },

  mounted () {
    this.fixFacebookHeight()
  },

  methods: {
    ...sharedMethods,

    setHtmlTagLang () {
      const htmlElement = document.documentElement
      htmlElement.setAttribute('lang', this.lang)
    },

    // Fix breakpoints not working in Facebook Mobile browser
    fixFacebookHeight () {
      this.$vuetify.clientHeight--
      this.$nextTick(() => {
        this.$vuetify.clientHeight++
      })
      setTimeout(() => {
        this.fixFacebookHeight()
      }, 500)
    },

    scrollHandler () {
      this.scrolledTop = window.scrollY
    },

    updateWindowWidth () { // Resize handler not working as expected on mobile, fb?
      if (window.innerWidth !== this.windowWidth) {
        this.windowWidth = window.innerWidth
      }
      setTimeout(() => {
        this.updateWindowWidth()
      }, 250)
    },

    resizeHandler () {
      this.windowHeight = window.innerHeight
      this.windowWidth = window.innerWidth
    },

    tryOldUrlRedirect () {
      const pathName = window.location.pathname
      if (!pathName) { return }
      const pathParts = pathName.split('/')
      if (!pathParts || pathParts.length < 2) { return }
      let key = pathParts[1] + '/' + pathParts[2]
      const newLangs = {
        eng: 'en',
        fin: 'fi',
        est: 'et',
        // rus: 'ru',
        esp: 'es'
      }
      const objectLinkWithoutLang = oldUrls['eng/' + pathParts[1]]
      if (oldUrls[key] || objectLinkWithoutLang) {
        if (objectLinkWithoutLang) {
          key = 'eng/' + pathParts[1]
        }
        api.getOneItemWithQuery('objects', oldUrls[key], [])
          .then(object => {
            this.$router.push({ path: this.objectLinkWithLang(object, objectLinkWithoutLang ? 'en' : newLangs[pathParts[1]]) })
          })
      }
    },

    loadLocalFavorites () {
      const localFavorites = window.localStorage.getItem('my_favorites')
      try {
        if (localFavorites && JSON.parse(localFavorites)) {
          this.favorites = JSON.parse(localFavorites)
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log('local-storage-my-favorites', err)
      }
    },

    setBannersByLang (banners) {
      const bannersByLang = {}
      banners.forEach(banner => {
        const lang = banner.languageRef && banner.languageRef.languageCode || 'undefined'
        if (!bannersByLang[lang]) {
          bannersByLang[lang] = []
        }
        bannersByLang[lang].push(banner)
      })
      this.$store.dispatch('setVal', {
        k: 'bannersByLang',
        v: bannersByLang,
      })
    },

    setGalleriesByArticleId (galleries) {
      const byArticle = {}
      galleries.forEach(gallery => {
        const articleId = gallery.showForArticle ? gallery.showForArticle._id : 'none'
        if (!byArticle[articleId]) {
          byArticle[articleId] = []
        }
        byArticle[articleId].push(gallery)
      })
      this.$store.dispatch('setVal', {
        k: 'galleriesByArticleId',
        v: byArticle
      })
    },

    setPagesById (pages) {
      const pagesById = {}
      const pagesBySeoName = {}
      pages.forEach(page => {
        pagesById[page._id] = page
        this.languages.forEach(lang => {
          if (page['seoName_' + lang]) {
            pagesBySeoName[page['seoName_' + lang]] = page
          }
        })
      })
      this.$store.dispatch('setVal', {
        k: 'pagesById',
        v: pagesById
      })
      this.$store.dispatch('setVal', {
        k: 'pagesBySeoName',
        v: pagesBySeoName
      })
    },

    setTemplateVarsByLang (vars) {
      const templateVarsByLang = {};
      ['et', 'en', 'fi', 'es', 'ru'].forEach(lang => {
        templateVarsByLang[lang] = {}
        vars.forEach(prop => {
          templateVarsByLang[lang][prop.propertyName] = prop['translation_' + lang]
        })
      })
      this.$store.dispatch('setVal', {
        k: 'templateVarsByLang',
        v: templateVarsByLang,
      })
    },
  },
}
</script>

<style src="./components/App/App.scss" lang="scss" />
<style src="./styles/Layout.scss" lang="scss" />
<style src="./styles/Header.scss" lang="scss" />
<style src="./styles/HeaderMobile.scss" lang="scss" />
<style src="./styles/List.scss" lang="scss" />
<style src="./styles/ListTopFilters.scss" lang="scss" />
<style src="./styles/ListObject.scss" lang="scss" />
<style src="./styles/ObjectInfo.scss" lang="scss" />
<style src="./styles/ObjectView.scss" lang="scss" />
<style src="./styles/Form.scss" lang="scss" />
<style src="./styles/SearchForm.scss" lang="scss" />
<style src="./styles/VuetifyOverwrites.scss" lang="scss" />
<style src="./styles/Tooltip.scss" lang="scss" />
<style src="./styles/Ported/PortedGeneral.scss" lang="scss" />
<style src="./styles/Ported/PortedCalendar.scss" lang="scss" />
